/**
 * @file index.js
 * @author sunxiaofeng01
 * @desc 百家号发文 —— 法律
 */

import Vuex from 'vuex';
import bendsdk from '@baidu/bend-plugin-sdk';
import store from '@/store/index';
import eventBus from '@/store/modules/EventBus';
const EventBus = new Vuex.Store(eventBus);

const routes = [
    {
        path: '/bjhRegister',
        name: 'bjhRegister',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue'),
        // 拦截路由，直接跳转到百家号文章管理页面
        beforeEnter: (to, from, next) => {
            const userInfo = store?.state?.lawStore?.userInfoNew || {};
            const {lawyer_info = {}} = userInfo;
            const {
                name,
                personal_intro,
                personal_avatar,
                identity_national_image,
                identity_head_image
            } = lawyer_info || {};
            if (!name
                || !personal_intro
                || !personal_avatar
                || !identity_national_image
                || !identity_head_image) {
                EventBus.commit('emitEvent', {name: 'global_authentice'});
                next(false);
            }
            else {
                next(true);
            }
        }
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class bjhSetting extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
